import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import Header from '../makeRequest/header/Header'
import { useDispatch, useSelector } from 'react-redux'
import Dialog from '../../../components/dialog/Dialog'
import { RootState } from '../../reducers'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { useMediaQuery } from 'react-responsive'
import { useIntl } from 'react-intl'
import { SpecificationsModel } from '../requestsModel'
import fetchFactory from '../../../utils/fetchFactory'
import { configEnum } from '../../../enums/fetchFactoryEnum'
import errorCatcher from '../../../utils/errorCatcher'
import RequestForm from '../makeRequest/stepper/step4/RequestForm'
import { FileModel } from '../../../types/fields/fieldsModel'
import { getModalContent, isModalVisible } from '../../reducers/modal/selector'
import { modalTypes } from '../../../enums/modalTypeEnum'
import { hideModal } from '../../reducers/modal/actions'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			formLargeScreenStyle: {
				width: '60%',
				maxWidth: 900,
				margin: '25px auto 0'
			},
			formSmallScreenStyle: {
				marginTop: 40
			}
		}
	)
)

const ERROR_CATCHER_ID: string = 'response_form'

interface ResponseModalModel {
	id: string,
	title: string,
	callback?: () => {}
}

interface DataModel {
	eft_message: string,
	eft_demande: string,
	piecesjointes?: FileModel[]
}

const Response = () => {
	const classes = useStyle()
	const intl = useIntl()
	const isOpen = useSelector((state: RootState) => isModalVisible(state, modalTypes.response))
	const modalContent: ResponseModalModel = useSelector((state: RootState) => getModalContent(state, modalTypes.response))
	const dispatch = useDispatch()
	const [loading, setLoading] = useState<boolean>(false)

	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const formClass: ClassValue = classNames(
		isLargeScreen ? classes.formLargeScreenStyle : classes.formSmallScreenStyle
	)

	const closeModal = () => {
		dispatch(
			hideModal(modalTypes.response)
		)
	}

	const onSubmit = (values: SpecificationsModel) => {
		setLoading(true)

		const data: DataModel = {
			eft_demande: modalContent.id || '',
			eft_message: values.message,
			piecesjointes: values.attachment
		}

		fetchFactory(
			`/api/ec_${process.env.REACT_APP_TARGET}/demande/createEchange`,
			{
				body: JSON.stringify(data),
				method: configEnum.post
			}
		)
			.then(
				() => {
					dispatch(
						hideModal(modalTypes.response)
					)
					if (modalContent.callback) {
						modalContent.callback()
					}
				}
			)
			.catch(
				(err) => {
					dispatch(errorCatcher(err, ERROR_CATCHER_ID))
				}
			)
			.finally(
				() => {
					setLoading(false)
				}
			)
	}

	const validate = (values: SpecificationsModel) => {
		const errors: any = {}

		if (!values.message) {
			errors.message = intl.formatMessage(
				{
					id: 'global.errors.required',
					defaultMessage: 'Requis*',
					description: 'Required message'
				}
			)
		}

		return errors
	}

	return (
		<Dialog
			onCloseDialog={closeModal}
			open={isOpen}
		>
			<>
				<Header
					closeDialog={closeModal}
					fromType={modalTypes.response}
					title={modalContent.title}
				/>

				<div className={formClass}>
					<RequestForm
						loading={loading}
						onSubmit={onSubmit}
						validate={validate}
						fromType={modalTypes.response}
					/>
				</div>
			</>
		</Dialog>
	)
}

export default Response
